"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _Icon = _interopRequireDefault(require("../Icon"));

var _ThemeProvider = require("../../theme/ThemeProvider");

var _style = _interopRequireDefault(require("./style"));

var _classnames = _interopRequireDefault(require("classnames"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _ThemeProvider.createUseStyles)(_style["default"]);

var IconButton = function IconButton(_ref) {
  var glyph = _ref.glyph,
      _ref$kind = _ref.kind,
      kind = _ref$kind === void 0 ? 'default' : _ref$kind,
      _ref$compressed = _ref.compressed,
      compressed = _ref$compressed === void 0 ? false : _ref$compressed,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      className = _ref.className,
      rest = (0, _objectWithoutProperties2["default"])(_ref, ["glyph", "kind", "compressed", "disabled", "className"]);
  var theme = (0, _ThemeProvider.useTheme)();
  var classes = useStyles({
    theme: theme,
    props: {
      kind: kind,
      compressed: compressed,
      disabled: disabled
    }
  }); // Have to set inline styles as Entypo sets them inline

  var iconStyle = {
    width: 12,
    height: 'auto',
    fill: theme['$button-icon-alt']
  };

  if (compressed) {
    iconStyle = _objectSpread(_objectSpread({}, iconStyle), {}, {
      fill: theme['$button-icon-main']
    });
  } else if (kind === 'compact') {
    iconStyle = _objectSpread(_objectSpread({}, iconStyle), {}, {
      width: 16
    });
  }

  return /*#__PURE__*/_react["default"].createElement("button", (0, _extends2["default"])({
    className: (0, _classnames["default"])(classes.IconButton, className),
    disabled: disabled
  }, rest), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    glyph: glyph,
    style: iconStyle
  }));
};

var _default = IconButton;
exports["default"] = _default;
//# sourceMappingURL=index.js.map